import { gql, useQuery } from "@apollo/client";
import { Button, Input, Layout, Menu, PageHeader, Row, Table } from "antd";
import { useApplicationContext } from "components/Application";
import { CenterSpinner } from "components/CenterSpinner";
import moment from "moment";
import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";

const orderDocumentsQuery = gql`
  query(
    $pagination: ConnectionPagination
    $sorting: OrderDocumentSorting
    $searchQuery: String
    $status: String
    $salespersonId: ID
  ) {
    orderDocuments(
      pagination: $pagination
      sorting: $sorting
      searchQuery: $searchQuery
      status: $status
      salespersonId: $salespersonId
    ) {
      nodes {
        id
        seasonKind
        updatedAt
        document
        quantity
        total
        user {
          id
          companyName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        page
        size
      }
      totalCount
      totalPages
    }
  }
`;

export const List: React.FC<{}> = () => {
  const { session } = useApplicationContext();
  const [searchQuery, setSearchQuery] = useState<string>("");

  const salesperson_id = session.currentUser.role === "SALESPERSON" ? session.currentUser.id : "admin";

  const variables = {
    pagination: { page: 1, pageSize: 0 },
    orderBy: { direction: "DESC", field: "INSERTED_AT" },
    status: "cart",
    salespersonId: salesperson_id,
    searchQuery,
  };
  const { loading, data } = useQuery(orderDocumentsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;

  const handleSearch = (value: string) => setSearchQuery(value);
  const handleSearchCancel = () => setSearchQuery("");
  const handleTableChange = () => {};

  const columns = [
    {
      title: "Customer",
      render: (resource: any) => (
        <NavLink to={resource.id}>{resource.user ? resource.user?.companyName : "---"}</NavLink>
      ),
    },
    {
      title: "Kind",
      render: (resource: any) => (resource.seasonKind === "stock" ? "ORDINE MAGAZZINO" : "ORDINE STAGIONALE"),
    },
    {
      title: "Updated",
      render: (resource: any) => moment(resource.updatedAt).format("DD-MM-YYYY"),
    },
    {
      title: "Total Qty",
      dataIndex: "quantity",
    },
    {
      title: "Total",
      dataIndex: "total",
    },
  ];

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Input.Search
              placeholder="search"
              onSearch={handleSearch}
              key={variables.searchQuery ?? "__search__"}
              defaultValue={variables.searchQuery ?? ""}
              style={{ width: 500, margin: "16px 30px" }}
              />
            <Button disabled={searchQuery.length === 0} onClick={handleSearchCancel} style={{ margin: "16px 0" }}>
              Cancel
            </Button>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <PageHeader ghost={true} title="Carts" />
        <Layout.Content className="content">
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={data?.orderDocuments.nodes}
            pagination={{
              hideOnSinglePage: true,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range} of ${total}`,
              total: data?.totalCount ?? 0,
            }}
            onChange={handleTableChange}
          />
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
